export const checkFilesType = (file: File) => {
  return ["image/jpeg", "image/jpg", "image/png", "application/pdf"].includes(file.type);
};

export const convertPath = (url: string) => {
  if (url.includes("designwhos")) {
    return "Designwhos";
  }
  if (url.includes("energyx")) {
    return "EnergyxX";
  }

  if (url.includes("tomarch")) {
    return "Tomarch";
  }
};
